import React, { useState, useEffect } from 'react';
import { useAuthState, useAuthDispatch } from 'context';
import { useParams, Redirect } from 'react-router-dom';
import {
  saveGroupLoginGroupId,
  setIntervalX,
  openGroupLoginInExtension,
  appEnvironment,
  trackInfo,
  infoMessage,
  trackError,
  errorMessage,
} from 'helpers';
import { isExtensionInstalled, pingExtension } from 'helpers/extension';
import { AuthLoader } from './components/AuthLoader';

export const GroupLoginScreen: React.FC = () => {
  const { groupId } = useParams();
  const { isAuthenticated } = useAuthState();
  const authDispatch = useAuthDispatch();
  const [showLoading, setShowLoading] = useState(true);
  const [redirectToRoot, setRedirectToRoot] = useState(false);
  const isInExtension = appEnvironment === 'chrome';

  useEffect(() => {
    setTimeout(() => setShowLoading(false), 1100);
  }, []);

  useEffect(() => {
    if (isInExtension) {
      trackInfo(infoMessage.GroupInviteLandedInExtension);
      setShowLoading(false);
    } else {
      setIntervalX(
        () => {
          if (isExtensionInstalled) {
            trackInfo(infoMessage.GroupInviteExtensionFound);
            openGroupLoginInExtension(groupId as string);
          }
          pingExtension();
        },
        250,
        4
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (showLoading) {
    return <AuthLoader />;
  }

  if (isAuthenticated) {
    trackInfo(infoMessage.GroupInviteRedirectToGroup);
    return <Redirect to={`/group/${groupId}`} />;
  }

  saveGroupLoginGroupId(groupId as string)
    .then(() => {
      authDispatch({
        type: 'GROUP_LOGIN_SET_ID',
        payload: {
          groupLoginGroupId: groupId,
        },
      });
      trackInfo(infoMessage.GroupInviteSaved);
      setRedirectToRoot(true);
    })
    .catch(() => {
      trackError(errorMessage.FailedToSaveGroupInvite, null);
      setRedirectToRoot(true);
    });

  if (!redirectToRoot) {
    return <AuthLoader />;
  } else {
    trackInfo(infoMessage.GroupInviteMoveToLogin);
    return <Redirect to={`/`} />;
  }
};
